module.exports = __webpack_public_path__ + "img/lk_srv_en.66ac0e8a.svg";